import { Box, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { useState } from "react";
import { showWarningSwal } from "../../functions/alert";
import { isAdmin } from "../../functions/checkrole";
import { exportParticipants } from "../../functions/getData";
import EnhancedFilter from "../EnhancedFilter";
import Loader from "../general/Loader";
import NunitoText from "../general/NunitoText";
import ReusableButton from "../general/ReusableButton";
import ReusableTextField from "../general/ReusableTextField";

const boxStyle = { width: 1200, minHeight: 400, maxHeight: "90%" };
const exportTypeDivStyle = {
  display: "flex",
  alignItems: "center",
  marginLeft: 28,
};
const radioGroupStyle = { marginInline: "20px 50px" };
const radioStyle = { color: "#000" };
const buttonsContainerStyle = { marginBlock: 30, paddingInline: 100 };

const BASE_FILTER_URL = "participant/list?get_filter=";
const FILTER_WIDTH = 480;

export default function ExportParticipantModal({
  selected,
  setSelected,
  setSelecting,
  cancelExport,
  partData,
}) {
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("2");
  const [email, setEmail] = useState("");
  const [filterParams, setFilterParams] = useState({
    country: "",
    school: "",
    grade: "",
    status: "",
    competition: "",
    organization: "",
    private: "",
  });

  const updateFilter = (key, value) => {
    setFilterParams((prev) => ({
      ...prev,
      [key]: value,
      // clear school whenever competition changes since school options depend on it
      ...(key === "competition" && { school: "" }),
    }));
  };

  const adjustEndpoint = (baseEndpoint, currentKey) => {
    let endpoint = baseEndpoint;
    Object.entries(filterParams).forEach(([key, val]) => {
      if (val !== "" && key !== currentKey) {
        endpoint += `&${key}=${val}`;
      }
    });
    return endpoint;
  };

  const onSubmit = () => {
    if (!["0", "1"].includes(type))
      return showWarningSwal("Please select Export Type");
    let params = type === "1" ? "?export_type=for_ocs" : "?";
    if (selected.length) {
      params += `&ids=${selected.join(",")}`;
    } else {
      if (filterParams.organization)
        params += `&organization=${filterParams.organization}`;
      if (filterParams.competition)
        params += `&competition=${filterParams.competition}`;
      if (filterParams.country) params += `&country=${filterParams.country}`;
      if (filterParams.grade) params += `&grade=${filterParams.grade}`;
      if (filterParams.status) params += `&status=${filterParams.status}`;
      if (filterParams.private !== "")
        params += `&private=${filterParams.private}`;
      if (filterParams.school) params += `&school=${filterParams.school}`;
      if (email) params += `&email=${email}`;
    }
    setLoading(true);
    exportParticipants(params)
      .then(() => {
        cancelExport();
        setSelected([]);
        setSelecting([]);
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false));
  };
  return (
    <Box className="popUpModal horizontalScrollable" style={boxStyle}>
      <NunitoText
        value="Export To CSV"
        fontSize={30}
        fontWeight={600}
        color="#5E75C3"
        marginTop={20}
      />
      {loading ? (
        <Loader height={selected.length ? 186 : 414} />
      ) : (
        <>
          <div>
            <div style={exportTypeDivStyle}>
              <NunitoText
                value="Export Type: "
                fontSize={20}
                fontWeight={600}
              />
              <RadioGroup
                value={type}
                style={radioGroupStyle}
                onChange={(e) => setType(e.target.value)}
              >
                <Grid container>
                  <FormControlLabel
                    value="0"
                    control={<Radio style={radioStyle} />}
                    label="Raw Data"
                  />
                  <FormControlLabel
                    value="1"
                    control={<Radio style={radioStyle} />}
                    label="For OCS"
                  />
                </Grid>
              </RadioGroup>
            </div>

            {Boolean(selected.length) ? (
              `You have selected ${selected.length} participants`
            ) : (
              <>
                {isAdmin() && (
                  <Grid container justifyContent="space-evenly" sx={{ mb: 2 }}>
                    <EnhancedFilter
                      searchable
                      label="organization"
                      endpoint={adjustEndpoint(
                        `${BASE_FILTER_URL}organization`,
                        "organization"
                      )}
                      value={filterParams.organization}
                      onChange={(value) => updateFilter("organization", value)}
                      width={FILTER_WIDTH}
                    />
                    <EnhancedFilter
                      searchable
                      label="country"
                      endpoint={adjustEndpoint(
                        `${BASE_FILTER_URL}country`,
                        "country"
                      )}
                      value={filterParams.country}
                      onChange={(value) => updateFilter("country", value)}
                      width={FILTER_WIDTH}
                    />
                  </Grid>
                )}
                <Grid container justifyContent="space-evenly" sx={{ mb: 2 }}>
                  <EnhancedFilter
                    searchable
                    label="competition"
                    endpoint={adjustEndpoint(
                      `${BASE_FILTER_URL}competition`,
                      "competition"
                    )}
                    value={filterParams.competition}
                    onChange={(value) => updateFilter("competition", value)}
                    width={FILTER_WIDTH}
                  />
                  <EnhancedFilter
                    searchable
                    label="grade"
                    endpoint={adjustEndpoint(
                      `${BASE_FILTER_URL}grade`,
                      "grade"
                    )}
                    value={filterParams.grade}
                    onChange={(value) => updateFilter("grade", value)}
                    width={FILTER_WIDTH}
                  />
                </Grid>
                <Grid container justifyContent="space-evenly" sx={{ mb: 2 }}>
                  <EnhancedFilter
                    searchable
                    label="Status"
                    endpoint={adjustEndpoint(
                      `${BASE_FILTER_URL}status`,
                      "status"
                    )}
                    value={filterParams.status}
                    onChange={(value) => updateFilter("status", value)}
                    width={FILTER_WIDTH}
                  />
                  <EnhancedFilter
                    searchable
                    label="private"
                    endpoint={adjustEndpoint(
                      `${BASE_FILTER_URL}private`,
                      "private"
                    )}
                    value={filterParams.private}
                    onChange={(value) => updateFilter("private", value)}
                    width={FILTER_WIDTH}
                  />
                </Grid>
                <Grid container justifyContent="space-evenly" sx={{ mb: 2 }}>
                  <EnhancedFilter
                    searchable
                    label="school"
                    endpoint={adjustEndpoint(
                      `${BASE_FILTER_URL}school`,
                      "school"
                    )}
                    value={filterParams.school}
                    onChange={(value) => updateFilter("school", value)}
                    width={FILTER_WIDTH}
                    disabled={filterParams.competition === ""}
                  />
                  <ReusableTextField
                    marginRight={40}
                    type={"default"}
                    width={FILTER_WIDTH}
                    height={54}
                    placeholder={"Email"}
                    borderColor="#707070"
                    bgColor={"#fff"}
                    state={email}
                    setState={setEmail}
                  />
                </Grid>
              </>
            )}
          </div>
          <Grid
            container
            justifyContent="space-evenly"
            style={buttonsContainerStyle}
          >
            <ReusableButton
              text="Cancel"
              fontSize={22}
              height={60}
              width={300}
              bgColor="#8D8D8D"
              onClick={() => cancelExport()}
            />
            <ReusableButton
              text="Submit"
              fontSize={22}
              height={60}
              width={300}
              bgColor="#5E75C3"
              onClick={() => onSubmit()}
            />
          </Grid>
        </>
      )}
    </Box>
  );
}
